import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { ExternalLink } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const FreshaSettings = () => {
  const { data } = useQuery({ queryKey: ["fresha"], queryFn: () => api.get("/fresha").then((r) => r.data) });
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const qc = useQueryClient();
  useEffect(() => { if (data) setF({ enabled: data.enabled, shop_enabled: false, url: data.profile_url }); }, [data]);
  if (!f) return null;
  const save = async (next) => {
    setBusy(true);
    try { const { data: saved } = await api.put("/admin/settings/fresha", next); setF({ ...saved, shop_enabled: false }); qc.invalidateQueries({ queryKey: ["fresha"] }); toast.success("Fresha settings saved"); } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="ad-card pp-form" data-testid="fresha-settings">
      <h3>Fresha</h3>
      <p className="muted-sm">When bookings go to Fresha, every Book button opens Fresha and the website's booking form is hidden. Individual service links can be added in Services &amp; prices. Shop items are always sold on this website — use Shop sales under Features to choose between online payment or pay in store.</p>
      <label className="mu-field">Main Fresha page link
        <input type="url" value={f.url} onChange={(e) => setF({ ...f, url: e.target.value.trim() })} placeholder="https://www.fresha.com/a/…" data-testid="fresha-url-input" />
      </label>
      <label className="st-check"><input type="checkbox" checked={f.enabled} disabled={busy} onChange={(e) => save({ ...f, enabled: e.target.checked })} data-testid="fresha-enabled-checkbox" /> Send bookings to Fresha</label>
      <div className="req-actions">
        <button className="btn gold" disabled={busy} onClick={() => save(f)} data-testid="fresha-save-button">Save link</button>
        {f.url && <a className="btn light" href={f.url} target="_blank" rel="noopener noreferrer" data-testid="fresha-open-link"><ExternalLink size={14} /> Open</a>}
      </div>
    </div>
  );
};
